<template>
  <el-dialog :title="title" :visible.sync="dialogController" :width="width" :before-close="cancel" appendToBody center>
    <div class="contentBox out-box">
      <div class="contentLeft">
        <el-input
          size="small"
          placeholder="搜索部门"
          v-model="filterText"
          style="margin-bottom:10px">
        </el-input>

        <el-tree
          class="filter-tree"
          :data="data"
          node-key="key"
          icon-class="el-icon-folder"
          @node-click="currentClick"
          default-expand-all
          show-checkbox
          :check-strictly="true"
          :default-checked-keys="defaultList.map(i=>i.key)"
          @check="getChecked"
          :filter-node-method="filterNode"
          ref="tree1">
        </el-tree>
      </div>
      <!-- <div class="line"></div>
      <div class="contentRight">
        <div class="rightTitle">成员将属于以下部门</div>
        <div class="checkBox">
          <div class="checkItem" v-for="(item,index) in rightList" :key="item.key">
            <div>
              <i class="el-icon-folder"></i>
              <span>{{item.label}}</span>
            </div>
            <i class="el-icon-close" @click="deleteItem(index)"></i>
          </div>
        </div>
      </div> -->
    </div>
    <div slot="footer" style="text-align:right">
      <el-button @click="cancel" v-show="showCancel" size="medium">取 消</el-button>
      <el-button
        :disabled="disabledConfirm"
        type="primary"
        size="medium"
        v-show="showConfirm"
        @click="confirm"
        v-preventReClick
      >确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getWholeTree,formatTree,getTreeAndPerson } from '@/views/system-manage/organizational-structure/api'
export default {
  props: {
    companyId:{
      type:String
    },
    title: {
      type: String,
      default: '选择部门'
    },
    width: {
      type: String,
      default:function(){
        return '500px'
      }
    },
    dialogController: {
      type: Boolean,
      default: false
    },
    disabledConfirm: {
      type: Boolean,
      default: false
    },
    showCancel: {
      type: Boolean,
      default: true
    },
    showConfirm: {
      type: Boolean,
      default: true
    },
    defaultList:{
      type:Array,
      default:function(){
        return []
      }
    },
  },
  data(){
    return {
        filterText: '',
        data: [],
        rightList:[]
    }
  },

  watch: {
      filterText(val) {
        this.$refs.tree1.filter(val);
      },
      dialogController(){
        if(this.dialogController){
          this.getTree()
        }
      }
    },
  methods: {
    cancel () {
      this.$emit('cancelTree')
      this.rightList = []
    },
    confirm () {
      this.$emit('confirmTree',this.rightList)
      this.rightList = []
    },
    filterNode(value, data) {
      if (!value) return true;
        return data.label.indexOf(value) !== -1;
    },
    currentClick(data,node,el){
      // this.showCurrentTool = data.key
      if(!this.rightList.find(item=>item.key === data.key)){
          this.rightList.push(data)
      }
    },
    deleteItem(i){
      this.rightList.splice(i,1)
    },
    getChecked(checkedNodes,checkedKeys){
      this.$emit('getChecked',{checkedNodes,checkedKeys})
      // console.log(checkedNodes,checkedKeys)
      this.rightList = checkedKeys.checkedNodes
    },
    getTree(){
      getWholeTree(this.companyId).then(res=>{
        this.data = formatTree(res.data)
      })
      // getTreeAndPerson().then(res=>{
      //   console.log(res)
      // })
    }
  },
  created(){
  }
}
</script>

<style scoped>
  .contentBox{
    display: flex;
    justify-content: space-between;
  }
  .contentLeft{
    width: 90%;
    margin: 0 auto;
  }
  .contentRight{
    width:45%;
  }
  .line{
    width: 1px;
    margin-top: 50px;
    background: #ccc;
  }
  .rightTitle{
    font-size: 18px;
  }
  .checkBox{
    margin-top: 30px;
    overflow-y: auto;
    max-height: 300px;
  }
  .checkItem{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
  }
  .checkItem:hover{
    background: #eee;
    cursor: pointer;
  }
</style>


// WEBPACK FOOTER //
// src/components/treeDialog/index.vue